import { NavigateNextOutlined } from '@mui/icons-material';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

type BreadcrumbProps = {
  items: { text: string; url?: string }[];
};

const Breadcrumb = ({ items }: BreadcrumbProps) => (
  <Box>
    <Breadcrumbs aria-label="breadcrumb" color="black" separator={<NavigateNextOutlined fontSize="small" />}>
      {items.map(({ text, url }) =>
        !url ? (
          <Typography variant="h5" key={text}>
            {text}
          </Typography>
        ) : (
          <Link variant="h5" component={RouterLink} to={url} key={text}>
            {text}
          </Link>
        ),
      )}
    </Breadcrumbs>
  </Box>
);

export default Breadcrumb;
